import { render, staticRenderFns } from "./PlaceholderItem.vue?vue&type=template&id=5f7915ba&functional=true&"
import script from "./PlaceholderItem.vue?vue&type=script&lang=js&"
export * from "./PlaceholderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports